import { ClipboardEventHandler } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField, TextFieldProps } from '@mui/material';
import { IkpuField, IkpuFieldProps } from './IkpuField';

// ----------------------------------------------------------------------

export type RHFIkpuFieldProps = Omit<IkpuFieldProps, 'renderInput'> & {
  name: string;
  label?: string;
  helperText?: React.ReactNode;
  TextFieldProps?: Omit<TextFieldProps, 'label' | 'error' | 'helperText'>;
  fieldPrefix?: string;
};

// ----------------------------------------------------------------------

export const RHFIkpuField = (props: RHFIkpuFieldProps) => {
  const { name, label, helperText, TextFieldProps, fieldPrefix, ...restOfProps } = props;
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { ref, onChange, ...restOfFiledProps }, fieldState: { error } }) => {
        const reassignedOnChange: IkpuFieldProps['onChange'] = (_, value) => {
          onChange(value);
        };

        const handlePaste: ClipboardEventHandler<HTMLInputElement> = event => {
          event.preventDefault();

          const clipboardData = event.clipboardData.getData('text');

          onChange(clipboardData.trim());
        };

        return (
          <IkpuField
            {...restOfFiledProps}
            fieldPrefix={fieldPrefix}
            onChange={reassignedOnChange}
            onPaste={handlePaste}
            renderInput={inputParams => (
              <TextField
                error={!!error}
                label={label}
                placeholder="Поиск"
                helperText={error ? error?.message : helperText}
                {...TextFieldProps}
                {...inputParams}
              />
            )}
            {...restOfProps}
          />
        );
      }}
    />
  );
};
